module.exports = __webpack_public_path__ + "static/media/hatziq_cartoon_v1.9a557a10.png";